

const RoleNames = {
    ClientStaff: 'ClientStaff',
    Admin: 'Admin',
    ClientDepartment: 'ClientDepartment',
    Supplier: 'Supplier',
    Client: 'Client'
};

const roles = [{ name: 'Public', color: 'lightGreen' }, { name: 'Admin', color: 'yellow' }, { name: 'Client', color: 'aquamarine' }, { name: 'ClientStaff', color: 'aquamarine' }, { name: 'ClientDepartment', color: 'aquamarine' },{ name: 'Supplier', color: 'lightBlue' }, { name: 'System', color: 'lightGrey' }];

// https://localhost:44327/addclient/7fe31713-bc22-4a3d-8dcd-8c31167f2257/CfDJ8JvOnfII9SdHrOA4BDFsYNn3MIfYJwTr99u6OSsPNdYaBCFKQHr08x9W8mD36/q66XdoxAbCUOmZgQGOABi1K1f7wbjx7YYZdxgAwv8WkP8UN1dytNgCijDCG3GDm2KONtmK2Z6fCVYi/HbR6V6GkJhHUlbVpGddOlx3EJMN9n9CLNxx8ne5cKwY7K8eI0QPAnEovu-qWk52owL1RjVWDkkxFXycQR-VPatcTLmVkiAm4ZayCfzaUtY8mQoASbWG2g
const charterRequestStatus = {
    pending: 'Pending',
    biddingClosed: 'Bidding Closed',
    pendingConfirmation: 'Pending Confirmation',
    finished: 'Finished',
    void: 'Void',
    confirmed: 'Confirmed',
    rejected: 'Rejected',
    cancelled: 'Cancelled',
    live:'Live'
};
const apiKey = process.env.REACT_APP_API_KEY;
const prefix = '/api/';
const authPrefix = 'api/accounts/';
const authEndpoints = {
    acceptSupplier: authPrefix + 'acceptSupplier/',
    tryAcceptSupplier: authPrefix + 'tryAcceptSupplier/',
    acceptAdmin: authPrefix + 'acceptAdmin/',
    tryAcceptAdmin: authPrefix + 'tryAcceptAdmin/',

    acceptCharterAdmin: authPrefix + 'acceptCharterAdmin/',
    tryAcceptCharterAdmin: authPrefix + 'tryAcceptCharterAdmin/',
    

    acceptClient: authPrefix + 'acceptClient/',
    tryAcceptClient: authPrefix + 'tryAcceptClient/',
    acceptClientDepartment: authPrefix + 'acceptClientDepartment/',
    tryAcceptClientDepartment: authPrefix + 'tryAcceptClientDepartment/',
    acceptClientStaff: authPrefix + 'acceptClientStaff/',
    tryAcceptClientStaff: authPrefix + 'tryAcceptClientStaff/',
    resetUserPassword: authPrefix + 'resetMyPassword/',
    checkEmail: authPrefix + 'checkEmail',
    checkEmailExists: authPrefix + 'checkEmailExists',
    requestPasswordReset: authPrefix + 'requestPasswordReset',
    enrolSupplier: authPrefix + 'enrolSupplier',
    enrolClient: authPrefix + 'enrolClientStaff',
    confirmSupplier: authPrefix + 'confirmSupplier',
    confirmClientStaff: authPrefix + 'confirmClientStaff',
    getLocationStates: authPrefix + 'getLocationStates',
    airportLookup: authPrefix + 'airportLookup/',
    jobLookup: authPrefix + 'jobLookup/',
    getIndicitaveFlight: authPrefix + 'getIndicitaveFlight',
};
const endpoints = {
    getCharterType: authPrefix + 'charterType',
    apiVersion: prefix + 'charterRequest/apiVersion',

    airportLookupList: prefix + 'admin/airportLookupAll/',
    airportLookupAll: prefix + 'admin/airportLookupAll',
    addAirportLookup: prefix + 'admin/addAirportLookup',
    updateAirportLookup: prefix + 'admin/updateAirportLookup',
    deleteAirportLookup: prefix + 'admin/deleteAirportLookup',
    getAllAdmins: prefix + 'admin/getAllAdmins/',
    getAdmin: prefix + 'admin/getAdmin/',
    updateAdmin: prefix + 'admin/updateAdmin/',
    addAdmin: prefix + 'admin/addAdmin/',
    getAllCharterAdmins: prefix + 'charterAdmin/getAllCharterAdmins/',
    getCharterAdmin: prefix + 'charterAdmin/getCharterAdmin/',
    updateCharterAdmin: prefix + 'charterAdmin/updateCharterAdmin/',
    addCharterAdmin: prefix + 'charterAdmin/addCharterAdmin/',
    charterReport: prefix + 'admin/getCharterReport/',
    getAllClients: prefix + 'admin/getAllClients',
    getAllPossibleClients: prefix + 'admin/getAllPossibleClients',
    resetPassword: prefix + 'admin/resetPassword',
    changeEmail: prefix + 'admin/changeEmail',
    sendEmails: prefix + 'admin/sendEmails',
    getTargetsForEntity: prefix + 'admin/getEntityTargets/',
    getDateFields: prefix + 'admin/dateFields',
    getTermsNames: prefix + 'admin/getTermsNames',
    getEmailTemplates: prefix + 'admin/getEmailTemplates',
    getUnCheckedDocuments: prefix +'admin/getUnCheckedDocuments',
    getEmailTemplate: prefix + 'admin/getEmailTemplate',
    getTerms: prefix + 'admin/getTerms',
    getTermsAndConditionsTypes: prefix + 'admin/getTermsAndConditionsTypes',
    getTermsAndConditions: prefix + 'admin/getTermsAndConditions',
    saveTerms: prefix + 'admin/updateTerms',
    setEmailTemplate: prefix + 'admin/setEmailTemplate',
    newEmailTemplate: prefix + 'admin/addEmailTemplate',
    setTerms: prefix + 'admin/setTerms',
    getReasonNames: prefix + 'admin/getReasonNames',
    getAllMessages: prefix + 'admin/getAllMessages/',
    getAllSuppliers: prefix + 'admin/getAllSuppliers',
    addClient: prefix + 'admin/addClient',
    addClientDepartment: prefix + 'admin/addClientDepartment',
    addClientStaff: prefix + 'admin/addClientStaff',
    getMessage: prefix + 'admin/getMessage/',
    updateMessage: prefix + 'admin/updateMessage',
    getAllClientDepartments: prefix + 'admin/getAllClientDepartments/',
    getAllClientStaff: prefix + 'admin/getAllClientStaff/',
    getSettingsNames: prefix + 'admin/getSettingsNames/',
    getSettingsValues: prefix + 'admin/getSettings/',
    updateSetting: prefix + 'admin/updateSetting/',
    addSetting: prefix + 'admin/addSetting/',
    moveClientToDepartment: prefix + 'admin/moveClientToDepartment/',
    moveDepartmentToStaff: prefix + 'admin/moveDepartmentToStaff/',
    changeMasterClient: prefix + 'admin/changeMasterClient/',
    changeMasterDepartment: prefix + 'admin/changeMasterDepartment/',
    updateAcknowledged: prefix + 'admin/updateAcknowledged/',
    payloadReport: prefix + 'admin/getPayLoadReport/',
    departureReport: prefix + 'admin/getDepartureReport/',

    logoutUser: prefix + 'logoutUser',

    getAccountTermsAndConditions: prefix + 'client/getTermsAndConditions',
    acceptTerms: prefix + 'client/acceptTerms',
    getMarginDetails: prefix + 'client/getMarginDetails/',
    updateMarginDetails: prefix + 'client/updateMarginDetails/',
    getAllClientMessages: prefix + 'client/getAllClientMessages/',
    getOnlyClientMessages: prefix + 'client/getOnlyClientMessages/',
    getAllClientDepartmentMessages: prefix + 'client/getAllClientDepartmentMessages/',
    getOnlyClientDepartmentMessages: prefix + 'client/getOnlyClientDepartmentMessages/',
    getAllClientStaffMessages: prefix + 'client/getAllClientStaffMessages/',

    getSettings: prefix + 'charterRequest/settings/',


    getCharterDetails: prefix + 'charterRequest/charterType',
    getCharterRequest: prefix + 'charterRequest/get/',
    getCharterRequestFull: prefix + 'charterRequest/full/',
    getCharterRequestBids: prefix + 'charterRequest/getBids/',
    getCharterRequestByBidId: prefix + 'charterRequest/getByBidId/',
    newCharterRequest: prefix + 'charterRequest/newCharterRequest',
    adminCharterRequests: prefix + 'charterRequest/admin/all',
    updateCharterRequest: prefix + 'charterRequest/updateCharterRequest/',
    updateManifest: prefix + 'charterRequest/updateManifest/',
    cloneCharterRequest: prefix + 'charterRequest/cloneCharterRequest',
    getSupplierCharterRequestsByStatus: prefix + 'charterRequest/supplierByStatus/',
    getClientOnlyCharterRequestsByStatus: prefix + 'charterRequest/all/self/',
    getClientAllCharterRequestsByStatus: prefix + 'charterRequest/all/client/',
    getClientDepartmentAllCharterRequestsByStatus: prefix + 'charterRequest/all/department/',
    getClientDepartmentStaffAllCharterRequestsByStatus: prefix + 'charterRequest/all/staff/',

    updateCharterShare: prefix + 'charterRequest/updateCharterShare/',
    getCharterShare: prefix + 'charterRequest/getShareById/',
    adminCharterShares: prefix + 'charterRequest/share/admin',
    getSupplierCharterShareByStatus: prefix + 'charterRequest/share/supplier',
    getClientDepartmentAllCharterShareByStatus: prefix + 'charterRequest/share/department',
    getClientOnlyCharterShareByStatus: prefix + 'charterRequest/share/staff',
    getClientAllCharterShareByStatus: prefix + 'charterRequest/share/client',

    getChangeCharter: prefix + 'charterRequest/getChangeCharterById/',
    updateChangeCharter: prefix + 'charterRequest/updateChangeCharter/',
    addChangeCharter: prefix + 'charterRequest/newChangeCharter/',
    getSupplierChangeCharterByStatus: prefix + 'charterRequest/change/supplier/',
    getClientDepartmentAllChangeCharterByStatus: prefix + 'charterRequest/change/department/',
    getClientOnlyChangeCharterByStatus: prefix + 'charterRequest/change/staff/',
    getClientAllChangeCharterByStatus: prefix + 'charterRequest/change/client/',
    adminCharterChange: prefix + 'charterRequest/change/admin/',
    getClientDepartmentStaffAllChangeCharterByStatus: prefix + 'charterRequest/change/staff/',

    updateCharterSharePurchase: prefix + 'charterRequest/updateCharterSharePurchase/',
    getCharterSharePurchase: prefix + 'charterRequest/getSharePurchaseById/',
    adminCharterSharePurchases: prefix + 'charterRequest/sharePurchases/admin',
    getSupplierCharterSharePurchasesByStatus: prefix + 'charterRequest/sharePurchases/supplier',
    getClientDepartmentAllCharterSharePurchasesByStatus: prefix + 'charterRequest/sharePurchases/department',
    getClientOnlyCharterSharePurchasesByStatus: prefix + 'charterRequest/sharePurchases/staff',
    getClientAllCharterSharePurchasesByStatus: prefix + 'charterRequest/sharePurchases/client',
    getClientEmail: prefix + 'charterRequest/getClientEmail/',
    getSupplierEmail: prefix + 'charterRequest/getSupplierEmail/',
    marginUpdateAdmin: prefix + 'charterRequest/marginUpdate',
   
    getClient: prefix + 'client/get/',
    getClientsByStatus: prefix + 'client/getByStatus/',
    getClientDetails: prefix + 'client/get/',
    updateClient: prefix + 'client/update',
    getClientDepartmentsForClientByStatus: prefix + 'clientDepartment/all/',
    getClientDepartment: prefix + 'clientDepartment/get/',
    updateClientDepartment: prefix + 'clientDepartment/update',
    getClientStaff: prefix + 'clientStaff/get/',
    updateClientStaff: prefix + 'clientStaff/update/',

    getClientStaffForClient: prefix + 'client/getClientStaffForClient/',
    getClientStaffForDepartment: prefix + 'clientStaff/getClientStaffForDepartment/',

    newbid: prefix + 'suppliers/newBid',
    inExclusions: prefix + 'suppliers/inExclusions',
    getSupplierMessages: prefix + 'suppliers/getSupplierMessages/',
    getAllSupplierMessages: prefix + 'suppliers/getAllMessages/',
    addSupplier: prefix + 'suppliers/addSupplier',
    getSupplier: prefix + 'suppliers/get/',
    getSupplierByStatus: prefix + 'suppliers/getByStatus/',
    getAircraftForSupplier: prefix + 'suppliers/aircraft/getAll/',
    getAircraftByStatus: prefix + 'suppliers/aircraft/getByStatus/',
    getAircraft: prefix + 'suppliers/aircraft/get/',
    updateAircraft: prefix + 'suppliers/aircraft/update/',
    getAircraftImages: prefix + 'suppliers/aircraft/images/',
    getAircraftImage: prefix + 'suppliers/aircraft/image/get',
    addAircraftImage: prefix + 'suppliers/aircraft/image',
    getSupplierOptions: prefix + 'suppliers/getSupplierOptions',
    addAircraft: prefix + 'suppliers/aircraft/add/',
    getAircraftCategories: prefix + 'suppliers/categories',
    getInexclusions: prefix + 'suppliers/getInexclusions    /',
    updateSupplier: prefix + 'suppliers/update/',
    setSupplierStatus: prefix + 'suppliers/setSupplierStatus/',
    getSupplierDocument: prefix + 'suppliers/getSupplierDocument/',
    getSupplierOptionalDocuments: prefix + 'suppliers/getSupplierOptionalDocuments/',
    updateSupplierDocument: prefix + 'suppliers/addSupplierDocument/',
    getSupplierDocumentByStatus: prefix + 'suppliers/getSupplierDocuments/',
    getSupplierDocumentByFilter: prefix + 'suppliers/getSupplierDocumentsByFilter/',
    getSupplierBids: prefix + 'suppliers/bidHistories/',
    getSupplierBidsByStatus: prefix + 'suppliers/bidHistoriesByStatus/',
    getCurrencies: prefix + 'suppliers/getCurrencies',
    charterAvailable: prefix + 'suppliers/charterAvailable/',
    getSupplierSecondaryEmails: prefix + 'suppliers/getSecondaryEmails/',
    addSecondaryEmail: prefix + 'suppliers/addSecondaryEmail/',
    removeSecondaryEmail: prefix + 'suppliers/removeSecondaryEmail/',


    getAllEntities: prefix + 'entityState/getAllEntities/',
    getAllowedAction: prefix + 'entityState/getAllowedAction/',
    updateAllowedAction: prefix + 'entityState/updateAllowedAction/',
    deleteAllowedAction: prefix + 'entityState/deleteAllowedAction/',
    addAllowedAction: prefix + 'entityState/addAllowedAction',
    getStatusForEntity: prefix + 'entityState/getStatusForEntity/',
    getStatusForEntityAndStatus: prefix + 'entityState/getStatusForEntityAndStatus/',
    getStatusChangeEventsForEntity: prefix + 'entityState/getStatusChangeEventsForEntity/',
    getActionsForUser: prefix + 'entityState/getActionsForUser/',
    getActionsForEntity: prefix + 'entityState/getActions/',
    getActionsForEntityItem: prefix + 'entityState/getActionsForEntityItem/',
    getActionsForEntityList: prefix + 'entityState/getListActions/',
    updateValidStatus: prefix + 'entityState/updateValidStatus/',
    getStateChangeEvent: prefix + 'entityState/getStateChangeEvent/',
    updateStateChangeEvent: prefix + 'entityState/updateStateChangeEvent/',
    deleteStateChangeEvent: prefix + 'entityState/deleteStateChangeEvent/',
    addStateChangeEvent: prefix + 'entityState/addStateChangeEvent/',
    getStateChangeOptions: prefix + 'entityState/getStateChangeOptions/',
    getAccessorsForEntity: prefix + 'entityState/getAccessorsEntity/',
    getAllowedActionsOptions: prefix + 'entityState/getAllowedActionsOptions/',
    setItemStatus: prefix + 'entityState/setItemStatus/',
    getTimeline: prefix + 'entityState/getTimeline/',  

    logError: 'auth/logError/'

};

export { RoleNames, apiKey, endpoints, authEndpoints, charterRequestStatus, roles };